const STATUS_BY_STAGE = {
  manager: 'Waiting Manager Approval',
  accountsCheck: 'Waiting Accounts Check',
  hr: 'Waiting HR Review',
  admin: 'Waiting Admin Approval',
  accountsPayment: 'Waiting Accounts Payment'
};

const ACTION_BY_STATUS = {
  'Waiting Manager Approval': 'submitted_for_manager_approval',
  'Waiting Accounts Check': 'submitted_for_accounts_check',
  'Waiting HR Review': 'submitted_for_hr_review',
  'Waiting Admin Approval': 'submitted_for_admin_approval',
  'Waiting Accounts Payment': 'submitted_for_accounts_payment'
};

export const buildPaymentRequestWorkflow = (user, requestedAmount) => {
  const role = String(user?.role || '').toLowerCase();
  const approvalRoles = Array.isArray(user?.paymentRequestApprovalRoles) ? user.paymentRequestApprovalRoles : [];
  const isDepartmentManager = ['sales_manager', 'ops_manager'].includes(role);
  const isAccountsUser = role === 'accounts';
  const skipManagerApproval = isDepartmentManager || isAccountsUser
    || approvalRoles.some((approvalRole) => ['accounts_payment', 'accounts_check', 'hr_review'].includes(approvalRole));
  const skipAccountsCheck = approvalRoles.includes('accounts_check');
  const skipHrReview = approvalRoles.includes('hr_review');
  const requiresAdminApproval = Number(requestedAmount || 0) > 20000;

  let initialStatus = STATUS_BY_STAGE.manager;
  if (skipManagerApproval) {
    if (!skipAccountsCheck) initialStatus = STATUS_BY_STAGE.accountsCheck;
    else if (!skipHrReview) initialStatus = STATUS_BY_STAGE.hr;
    else if (requiresAdminApproval) initialStatus = STATUS_BY_STAGE.admin;
    else initialStatus = STATUS_BY_STAGE.accountsPayment;
  }

  return {
    originatingApprovalRoles: approvalRoles,
    skipManagerApproval,
    skipAccountsCheck,
    skipHrReview,
    requiresAdminApproval,
    initialStatus,
    submissionAction: ACTION_BY_STATUS[initialStatus]
  };
};

export const getStatusAfterAccountsCheck = (workflow, requestedAmount) => {
  const requiresAdminApproval = workflow?.requiresAdminApproval ?? Number(requestedAmount || 0) > 20000;
  if (!workflow?.skipHrReview) return STATUS_BY_STAGE.hr;
  return requiresAdminApproval ? STATUS_BY_STAGE.admin : STATUS_BY_STAGE.accountsPayment;
};

export const getStatusAfterHrReview = (workflow, requestedAmount) => {
  const requiresAdminApproval = workflow?.requiresAdminApproval ?? Number(requestedAmount || 0) > 20000;
  return requiresAdminApproval ? STATUS_BY_STAGE.admin : STATUS_BY_STAGE.accountsPayment;
};
